import React from "react";
import styled from "styled-components";
import { Form } from "antd";
import { RAButtonPrimary, RATextInput, RATypography } from "@/components/customs";

const template = ({
	errors,
	setErrors,
	password,
	setPassword,
	confirmPassowrd,
	setConfirmPassword,
	loading,
	handleResetPassword,
}) => {
	return (
		<Container>
			<Form layout="vertical">
				<FormInputWrapper>
					<WrapperTitle>
						<RATypography variant="h4">Forgot Password</RATypography>
					</WrapperTitle>
					<Form.Item>
						<RATextInput
							type="password"
							title="New Password"
							placeholder="Enter new password"
							value={password}
							onChange={(val) => {
								setPassword(val);
								setErrors({});
							}}
							error={errors?.new_password}
						/>
					</Form.Item>
					<Form.Item>
						<RATextInput
							type="password"
							title="Confirm Password"
							placeholder="Enter confirm password"
							value={confirmPassowrd}
							onChange={(val) => {
								setConfirmPassword(val);
								setErrors({});
							}}
							error={errors?.confirm_password}
						/>
					</Form.Item>
					<WrapperBottom justify="center">
						<RAButtonPrimary title="RESET" width="180px" loading={loading} onClick={handleResetPassword} />
					</WrapperBottom>
				</FormInputWrapper>
			</Form>
		</Container>
	);
};

const Container = styled.div`
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);
	width: 50vw;
	max-width: 620px;
	min-width: 343px;
`;
const FormInputWrapper = styled.div`
	align-self: center;
`;
const WrapperTitle = styled.div`
	margin-bottom: 30px;
	padding-left: 20px;
	border-left: 2px solid #ffb11a;
`;
const WrapperBottom = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 40px;
	gap: 12px;
`;

export { template };
